var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoMusic = function SvgIcoMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M128 128v228.6c37.3 11 64 40.6 64 75.4V223.8L448 147v145.5c37.3 11 64 40.6 64 75.4v-336c0-10.1-4.8-19.6-12.9-25.7-5.6-4-12.3-6.2-19.1-6.2-3.1 0-6.2.4-9.2 1.3l-320 96c-13.5 4.1-22.8 16.6-22.8 30.7",
    style: {
      opacity: 0.4
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 448c53 0 96-35.8 96-80s-43-80-96-80-96 35.8-96 80 43 80 96 80M96 512c53 0 96-35.8 96-80s-43-80-96-80-96 35.8-96 80 43 80 96 80",
    className: "ico-music_svg__fa-primary"
  })));
};
export default SvgIcoMusic;